export const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { render } = require('react-dom');

  // use data set as props
  nodeList.forEach((node) => render(<Component {...node.dataset} />, node));
};
